import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import noImage from "../../no_Image.jpg";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { updateComparisonData } from "../../../src/app/features/counter/counterSlice";
import "../../index.css";
import {
  setSelectedCamera,
  setSelectedSpecial,
  deleteSpecial,
  deleteCamera,
  setFinalData,
  updateCamera2,
  updateSpecial2,
  upsertLinkedLaborItem,
  deleteLinkedLaborItems,
} from "../../../src/app/features/counter/counterSlice";
import { useSelector, useDispatch } from "react-redux";

// Universal Data (Category CSV)
import { CategoryCsvData } from "../fetchData/CategoryCsvData.js";
import { ProductCsvData } from "../fetchData/ProductCsvData.js";
import { ProductOptionsCsvData } from "../fetchData/ProductOptionsCsvData.js";
import DisplayDrops from "./DisplayDrops.js";
import WarningComponent from "./WarningComponent.js";
import { calculateLineItem, getOptionEntries, getProductSku, getProductDisplayName } from "./quoteCalculator";

function Special(props) {
  const { categoryCSVQuery, isLoading1, isError1 } = CategoryCsvData();
  const { productCSVQuery, isLoading2, isError2 } = ProductCsvData();
  const { productOptionCSVQuery, isLoading3, isError3 } =
    ProductOptionsCsvData();

  const normalizeCsvValue = (value) => String(value || "").trim().toLowerCase();

  const parseCsvNumber = (value) => {
    const parsed = Number(String(value ?? "").trim());
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const splitCsvList = (value) =>
    String(value || "")
      .split(/[\/@|,]+/)
      .map((word) => normalizeCsvValue(word))
      .filter(Boolean);

  const hasSpecialCategoryPath = (product) =>
    splitCsvList(product && product.categories).includes("special");

  const getSpecialAutoQuantity = (product) => {
    const quantity = parseCsvNumber(product && product.extra_field_4);
    return quantity > 0 ? quantity : 0;
  };

  const hasExactCategory = (product, categoryName) =>
    splitCsvList(product && product.categories).includes(normalizeCsvValue(categoryName));

  const hasExactParent = (category, parentId) =>
    splitCsvList(category && category.category_parent).includes(normalizeCsvValue(parentId));

  const [isProductCSVLoaded, setProductCSVLoaded] = useState(false);
  const [isProductOptionsCSVLoaded, setProductOptionsCSVLoaded] =
    useState(false);
  const [hasError, setHasError] = useState(false);
  // Update loading status for Product CSV Data
  useEffect(() => {
    if (!isLoading2) {
      if (isError2) {
        console.error("Error loading Product CSV data:", isError2);
        setHasError(true);
      } else {
        setProductCSVLoaded(true);
      }
    }
  }, [isLoading2, isError2]);

  // Update loading status for Product Options CSV Data
  useEffect(() => {
    if (!isLoading3) {
      if (isError3) {
        console.error("Error loading Product Options CSV data:", isError3);
        setHasError(true);
      } else {
        setProductOptionsCSVLoaded(true);
      }
    }
  }, [isLoading3, isError3]);

  // Perform actions when both datasets are loaded
  // useEffect(() => {
  //   if (isProductCSVLoaded && isProductOptionsCSVLoaded) {
  //     if (!hasError) {
  //       console.log('Both datasets are loaded successfully');
  //       // Your data processing logic here
  //     }
  //   }
  // }, [isProductCSVLoaded, isProductOptionsCSVLoaded, hasError]);

  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const totalCamerasRequired = useSelector(
    (state) => state.counter1.totalCamera
  );
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [shows, setShows] = useState(false);
  const [showsCustom, setShowsCustom] = useState(false);

  const [CustomData, setCustomData] = useState({
    Product_Name: "CUSTOM",
    description: "",
    price: "",
  });
  const [count, setCount] = useState(1);
  const [customCount, setCustomCount] = useState(1);
  const [thumbimg, setThumbimg] = useState([]);
  const [totalPriceInTable, setTotalPriceInTable] = useState(0);
  const [filteredData, setfilteredData] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [filteredData2, setfilteredData2] = useState([]);
  const [categoryName2, setCategoryName2] = useState([]);
  const [finalDatas, setFinalDatas] = useState([]);
  const [dataProduct, setdataProduct] = useState({});
  const [finalNewState, setFinalNewState] = useState({});
  const [finalNewState2, setFinalNewState2] = useState({});
  const [finalNewState3, setFinalNewState3] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [priceList, setPriceList] = useState(0);
  const [unitCostInput, setUnitCostInput] = useState("");
  const [mergedState, setMergedState] = useState({});
  const [totalBracket, setTotalBracket] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [totalDrops, setTotalDrops] = useState(0);
  const [Loading, setLoading] = useState(false);

  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const [showButtons, setShowButtons] = useState(null);
  // useEffect(() => {
  //   const productAddedSuccessfully = localStorage.getItem('productAdded');

  //   if (!productAddedSuccessfully && totalNoOptions !== undefined) {
  //     for (let i = 1; i <= totalNoOptions; i++) {
  //       const item1 = {
  //         Camera_Base_Price: "39.99",
  //         Camera_Category_Name: "Hardware",
  //         Camera_Final_Price: 39.99,
  //         Camera_Quantity: 1,
  //         Product_Name: "KM",
  //         num_options: i.toString()
  //       };

  //       const item2 = {
  //         Camera_Base_Price: "169.99",
  //         Camera_Category_Name: "Displays",
  //         Camera_Final_Price: 169.99,
  //         Camera_Quantity: 1,
  //         Product_Name: "LCD-M",
  //         num_options: i.toString()
  //       };

  //       dispatch(setSelectedSpecial(item1));
  //       dispatch(setFinalData(item1));
  //       dispatch(setSelectedSpecial(item2));
  //       dispatch(setFinalData(item2));
  //     }

  //     localStorage.setItem('productAdded', 'productAdded');
  //   }
  // }, []);

  const countSpecial = useSelector((state) => state.counter1.selectedSpecial);

  // Disable Input State
  const [disableIt, setDisableIt] = useState("");
  const [bracketPrice, setBracketPrice] = useState(0); // Ex: Back Box $45. it'll store 45
  const [bracketNumber, setBracketNumber] = useState(0); // If he/she enter '10' it'll add 10
  const totalbracketPrice = bracketPrice * bracketNumber;
  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );
  const [showWarningComponent, setShowWarningComponent] = useState(false);

  const getItemSku = (item) =>
    String(item?.Product_Name || item?.id || item?.sku || item?.Name || "").trim();

  const isEnclosureItem = (item) => {
    const sku = getItemSku(item).toUpperCase();
    const categoryText = String(item?.categories || item?.Camera_Category_Name || "").toUpperCase();

    return (
      sku.startsWith("ENC") ||
      sku.includes("-ENC") ||
      sku.includes("ENC-") ||
      categoryText.includes("ENCLOSURE")
    );
  };

  const getAutoServiceFlag = (item) => {
    const explicitFlag = String(item?.extra_field_5 || item?.auto_service || "")
      .trim()
      .toUpperCase();

    if (explicitFlag === "AUTO_SVC_ENC") return "AUTO_SVC_ENC";

    // Backward-compatible fallback while CSV cleanup is in progress.
    // Allows enclosure products to trigger SVC-ENC even if extra_field_5 is still blank/1.
    if (isEnclosureItem(item)) return "AUTO_SVC_ENC";

    return explicitFlag;
  };

  const findServiceProduct = (serviceSku) =>
    (productCSVQuery || []).find(
      (product) => String(product.id || "").trim().toUpperCase() === serviceSku.toUpperCase()
    );

  const buildLinkedServiceLaborItem = (serviceSku, parentItem, automationType) => {
    const serviceProduct = findServiceProduct(serviceSku);
    const quantity = Number(parentItem?.Camera_Quantity || parentItem?.Product_Quantity || parentItem?.quantity || 1);
    const unitPrice = Number(
      areYouDealer === "Dealer Selected"
        ? serviceProduct?.price_2 || serviceProduct?.price || 0
        : serviceProduct?.price || serviceProduct?.price_2 || 0
    );

    return {
      id: serviceSku,
      Product_Name: serviceSku,
      name: serviceProduct?.name || serviceProduct?.description || serviceSku,
      Name: serviceProduct?.name || serviceProduct?.description || serviceSku,
      description: serviceProduct?.description || serviceProduct?.name || serviceSku,
      categories: serviceProduct?.categories || "Labor",
      category: "Labor",
      num_options: parentItem?.num_options || whichOption,
      quantity,
      Product_Quantity: quantity,
      pricePerItem: unitPrice,
      Product_Base_Price: unitPrice,
      totalPriceForItem: unitPrice,
      Product_Final_Price: unitPrice * quantity,
      extra_field_4: serviceProduct?.extra_field_4 || "0",
      autoAdded: true,
      autoLaborType: automationType,
      linkedParentUniqueID: parentItem?.uniqueID,
      linkedParentSku: parentItem?.Product_Name || parentItem?.id || "",
      uniqueID: "auto-" + automationType + "-" + (parentItem?.uniqueID || Date.now()),
    };
  };

  const syncAutoServiceLabor = (parentItem) => {
    if (!parentItem?.uniqueID) return;

    // Dealer quotes do not require automatic service labor.
    // If a linked labor item already exists for this parent, remove it.
    if (areYouDealer === "Dealer Selected") {
      dispatch(deleteLinkedLaborItems({ linkedParentUniqueID: parentItem.uniqueID }));
      return;
    }

    if (getAutoServiceFlag(parentItem) === "AUTO_SVC_ENC") {
      dispatch(upsertLinkedLaborItem(buildLinkedServiceLaborItem("SVC-ENC", parentItem, "AUTO_SVC_ENC")));
    } else {
      dispatch(deleteLinkedLaborItems({ linkedParentUniqueID: parentItem.uniqueID }));
    }
  };


  // 01 dec check
  const [basePrice3, setBasePrice3] = useState(0);
  const [cameraName3, setCameraName3] = useState("");

  // Code Debugging
  const [two, setTwo] = useState("");
  // Code Debugging

  // Unit Count Counter
  const [unitCounter, setUnitCounter] = useState(0);

  const getSpecialOptionSlots = (selectedItem) => {
    const slots = {};

    getOptionEntries(selectedItem, [
      "Camera_Category_Name",
      "Camera_Final_Price",
      "Camera_Base_Price",
      "Camera_Quantity",
      "Product_Final_Price",
      "Product_Base_Price",
      "Product_Quantity",
      "page",
      "image",
      "thumbnail",
    ]).forEach((option, index) => {
      const slot = index + 1;
      slots[`option${slot}_name`] = option.name;
      slots[`option${slot}_value`] = option.value;
      slots[`option${slot}_price`] = Number(option.price || 0);
    });

    return slots;
  };

  const specialData = [];
  countSpecial.map((selectedItem) => {
    let optionName1;
    let optionValue1;
    let optionPrice1;
    let optionName3;
    let optionValue3;
    let optionPrice3;
    let optionName6;
    let optionValue6;
    let optionPrice6;
    if (selectedItem["Edge Backup Recording"]) {
      optionName1 = "Edge Backup Recording";
      optionValue1 = selectedItem["Edge Backup Recording"];
      optionPrice1 = selectedItem["Edge Backup Recording_price"];
    }
    if (selectedItem["Audio"]) {
      optionName6 = "Audio";
      optionValue6 = selectedItem["Audio"];
      optionPrice6 = selectedItem["Audio_price"];
    }
    if (selectedItem["Color"]) {
      optionName3 = "Color";
      optionValue3 = selectedItem["Color"];
      optionPrice3 = selectedItem["Color_price"];
    }
    specialData.push({
      option: selectedItem.num_options,
      uniqueID: selectedItem.uniqueID,
      category: "Camera",
      unit_price: selectedItem.unitprice,
      Product_Name: selectedItem.Product_Name,
      Product_Description: selectedItem.Name,
      Name: selectedItem.Name || selectedItem.name,
      Product_Quantity: selectedItem.Camera_Quantity,
      Product_Base_Price: selectedItem.Camera_Base_Price,
      Product_Final_Price:
        selectedItem.Camera_Final_Price * selectedItem.Camera_Quantity,
      option1_name: optionName1,
      option1_value: optionValue1,
      option1_price: optionPrice1,
      option2_name: "Mounting Bracket",
      option2_value: selectedItem["Mounting Bracket"],
      option2_price: selectedItem["Mounting Bracket_price"],
      option3_name: optionName3,
      option3_value: optionValue3,
      option3_price: optionPrice3,
      option4_name: "MicroSD Card for Edge Recording",
      option4_value: selectedItem["MicroSD Card for Edge Recording"],
      option4_price: selectedItem["MicroSD Card for Edge Recording_price"],
      option5_name: "Power Adapter",
      option5_value: selectedItem["Power Adapter"],
      option5_price: selectedItem["Power Adapter_price"],
      thumbnail: selectedItem?.thumbnail || "",
      image1: selectedItem?.image1 || "",
      image2: selectedItem?.image2 || "",
      image3: selectedItem?.image3 || "",
      image4: selectedItem?.image4 || "",

      ...getSpecialOptionSlots(selectedItem),

      // Only include the "Audio" option if selectedItem["Audio"] is true
      ...(selectedItem["Audio"] && {
        option6_name: optionName6,
        option6_value: optionValue6,
        option6_price: optionPrice6,
      }),
    });
  });
  const tableData = specialData;

  React.useEffect(() => {
    let totalCty = 0;
    tableData.forEach((item) => {
      totalCty += parseInt(item.Camera_Quantity, 10);
    });
    setTotalQty(totalCty);
  }, [tableData]);

  React.useEffect(() => {
    let totalBkt = 0;
    tableData.forEach((item) => {
      const bracketSelected = parseInt(item.Bracket_Selected, 10);
      if (!isNaN(bracketSelected)) {
        totalBkt += bracketSelected;
      }
    });
    setTotalBracket(totalBkt);
  }, [tableData]);

  const handleClose2 = () => setShows(false);
  const handleShow2 = () => {
    if (totalCamerasRequired > totalQty) {
      setShows(true);
    } else {
      navigate("/hardware");
    }
  };

  React.useEffect(() => {
    let total = 0;
    tableData.forEach((item) => {
      total += parseFloat(item.Camera_Final_Price);
    });
    setTotalPriceInTable(total);
  }, [tableData]);

  const updateMergedState = () => {


    if (Object.keys(finalNewState2).length > 0) {
      setMergedState({
        ...finalNewState,
        ...finalNewState2,
      });
    } else {
      setMergedState({
        ...finalNewState,
        ...finalNewState2,
        ...finalNewState3,
      });
    }
  };

  React.useEffect(() => {
    updateMergedState();
  }, [finalNewState, finalNewState2, finalNewState3]);
  React.useEffect(() => {
    if (showButtons === "edit") {
      // Recalculate total price based on selected options
      let calculatedPrice = parseFloat(basePrice3);
      Object.keys(finalNewState2).forEach((key) => {
        const option = finalDatas
          .flat()
          .find(
            (opt) =>
              opt.featurecaption === key &&
              opt.featurename === finalNewState2[key]
          );
        if (option) {
          calculatedPrice += parseFloat(option.featureprice);
        }
      });
      setPriceList(calculatedPrice);
    }
  }, [finalNewState2, basePrice3, showButtons, finalDatas]);

  function addCamera() {
    mergedState.uniqueID =
      Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
    mergedState.num_options = whichOption;
    dispatch(setSelectedSpecial(mergedState));
    dispatch(setFinalData(mergedState));
    syncAutoServiceLabor(mergedState);

    setShow2(false);
    setUnitCounter(0);
  }

  // Modal-1 Open Dpk
  // const handleButtonClick = (e, category_name) => {
  //   setCategoryName(category_name);
  //   setShow(true);
  //   // Update 2

  //   const cameraData2 = productCSVQuery.filter((item) => {
  //     if (item.categories) {
  //       const categoriesWords = item.categories.split("/");
  //       if (areYouDealer === "Dealer Selected") {
  //         if (item.hide_2 === "0") {
  //           // return categoriesWords.find((word) => word.includes(category_name));
  //           if (
  //             categoriesWords.includes("Special") &&
  //             category_name === "WiFi"
  //           ) {
  //             return categoriesWords.find((word) =>
  //               word.includes(category_name)
  //             );
  //           } else if (
  //             !categoriesWords.includes("Special") &&
  //             category_name !== "WiFi"
  //           ) {
  //             return categoriesWords.find((word) =>
  //               word.includes(category_name)
  //             );
  //           }
  //         }
  //       } else if (areYouDealer !== "Dealer Selected") {
  //         if (item.hide_1 === "0") {
  //           // return categoriesWords.some((word) => category_name == word);
  //           // return categoriesWords.find((word) => word.includes(category_name));
  //           if (
  //             categoriesWords.includes("Special") &&
  //             category_name === "WiFi"
  //           ) {
  //             return categoriesWords.find((word) =>
  //               word.includes(category_name)
  //             );
  //           } else if (
  //             !categoriesWords.includes("Special") &&
  //             category_name !== "WiFi"
  //           ) {
  //             return categoriesWords.find((word) =>
  //               word.includes(category_name)
  //             );
  //           } else if (
  //             categoriesWords.includes("Special") &&
  //             category_name !== "WiFi"
  //           ) {
  //             return categoriesWords.find((word) =>
  //               word.includes(category_name)
  //             );
  //           }
  //         }
  //       }
  //     }
  //     // return false;
  //   });

  //   setfilteredData(cameraData2.sort((a, b) => ((parseInt(a.sorting, 10) || 0) - (parseInt(b.sorting, 10) || 0))));
  // };

  // Modal-1 Open Knm
  const handleButtonClick = (e, category_name) => {
    setCategoryName(category_name);
    setShow(true);
 
    const cameraData2 = productCSVQuery.filter((item) => {
      if (item.categories) {
        const hasCategory = hasExactCategory(item, category_name);

        if (hasCategory) {
          if (areYouDealer === "Dealer Selected" && item.hide_2 === "0") {
            return true;
          } else if (
            areYouDealer !== "Dealer Selected" &&
            item.hide_1 === "0"
          ) {
            return true;
          }
        }
      }
      return false;
    });

    setfilteredData(
      cameraData2.sort((a, b) => ((parseInt(a.sorting, 10) || 0) - (parseInt(b.sorting, 10) || 0)))
    );
  };

  // Modal-2 Open

  // Modal_1 function mein changes
  function modal_1(e, item, id, type) {
    setShowButtons(type);

    // Set base price based on mode. Auto-added Special items may only carry
    // the saved cart fields, so normalize all known aliases before rendering.
    if (type === "edit") {
      const editQuantity = Number(
        item.Camera_Quantity ?? item.Product_Quantity ?? item.quantity ?? 1
      ) || 1;
      const editBasePrice = Number(
        item.Camera_Base_Price ??
          item.Product_Base_Price ??
          item.pricePerItem ??
          item.unitprice ??
          item.price ??
          0
      ) || 0;
      const editUnitPrice = Number(
        item.Camera_Final_Price ??
          item.Product_FinalPrice ??
          item.Product_Final_Price ??
          editBasePrice
      );

      setBasePrice3(editBasePrice);
      setCount(editQuantity);
      setPriceList(Number.isFinite(editUnitPrice) ? editUnitPrice : editBasePrice);
    } else {
      const addBasePrice = Number(
        areYouDealer !== "Dealer Selected" ? item.price : item.price_2
      ) || 0;
      setBasePrice3(addBasePrice);
      setPriceList(addBasePrice);
    }

    // Load product options
    let result = [];
    let currentArray = [];
    for (let i = 0; i < productOptionCSVQuery.length; i++) {
      const item = productOptionCSVQuery[i];
      if (
        item.productid === id ||
        (currentArray.length > 0 && item.productid === "")
      ) {
        currentArray.push(item);
      } else if (currentArray.length > 0) {
        result = currentArray;
        currentArray = [];
      }
    }
    if (currentArray.length > 0) {
      result = [...currentArray];
    }

    const result1 = [];
    let currentArray1 = [];
    for (let i = 0; i < result.length; i++) {
      const item = result[i];
      if (item.productid === id) {
        if (currentArray1.length > 0) {
          result1.push([...currentArray1]);
          currentArray1 = [];
        }
        currentArray1.push(item);
      } else if (currentArray1.length > 0 || i === result.length - 1) {
        currentArray1.push(item);
      }
    }
    if (currentArray1.length > 0) {
      result1.push([...currentArray1]);
    }

    setFinalDatas(result1);

    // Set initial selected options in edit mode
    if (type === "edit") {
      const initialSelectedOptions = {};
      result1.forEach((optionGroup) => {
        const featureCaption = optionGroup[0].featurecaption;
        // Find the option that matches the saved value
        const savedOption = optionGroup.find(
          (opt) => opt.featurename === item[featureCaption]
        );
        if (savedOption) {
          initialSelectedOptions[featureCaption] = savedOption.featurename;
          initialSelectedOptions[`${featureCaption}_price`] =
            parseFloat(savedOption.featureprice) || 0;
        } else if (optionGroup.length > 0) {
          // Default to first option if no match found
          initialSelectedOptions[featureCaption] = optionGroup[0].featurename;
          initialSelectedOptions[`${featureCaption}_price`] =
            parseFloat(optionGroup[0].featureprice) || 0;
        }
      });
      setFinalNewState2(initialSelectedOptions);
    }

    setShow2(true);
    setShow(false);
    setCategoryName2(id);

    // Load product data
    let cameraData3;
    if (type == "edit") {
      cameraData3 = productCSVQuery.filter((product) => product.id === id);
      if (!cameraData3 || cameraData3.length === 0) {
        cameraData3 = [{ ...item, id: item.Product_Name || item.id }];
      }
    } else {
      cameraData3 = filteredData.filter((product) => product.id === id);
    }

    setfilteredData2(cameraData3);
    setdataProduct({
      ...item,
      id: item.id || item.Product_Name || id,
      name: item.name || item.Name,
      price:
        item.price ??
        item.Camera_Base_Price ??
        item.Product_Base_Price ??
        item.pricePerItem ??
        0,
      extra_field_5: item.extra_field_5,
    });
  }

  const specialData1 = categoryCSVQuery
    ? categoryCSVQuery.filter((item) => {
        return (
          hasExactParent(item, "101")
          //   ||
          //     item.category_parent.includes("107")
          // ||
          // item.category_parent.includes("12") ||
          // item.id.includes("90")
          // || (item.category_parent.includes("12") && item.id.includes("90")) // added it seperately so that accessories category can come under the special category
        );
      })
    : [];

  // Remove blank id code
  const demoArr = [];
  if (productCSVQuery && specialData1) {
    productCSVQuery.forEach((item1) => {
      specialData1.forEach((item) => {
        if (item1.categories) {
          const testVariable = hasExactCategory(item1, item.category_name);
          if (areYouDealer === "Dealer Selected") {
            if (testVariable === true && item1.hide_2 === "0") {
              demoArr.push(item);
            }
          } else if (areYouDealer !== "Dealer Selected") {
            if (testVariable === true && item1.hide_1 === "0") {
              demoArr.push(item);
            }
          }
        }
      });
    });

    demoArr.sort((a, b) => {
      return (parseInt(a.sorting) || 0) - (parseInt(b.sorting) || 0);
    });
  }

  function filterUniqueObjects(arr, property) {
    const uniqueSet = new Set();
    return arr.filter((obj) => {
      const value = obj[property];
      if (uniqueSet.has(value)) {
        return false; // Duplicate, skip this object
      }
      uniqueSet.add(value);
      return true; // Unique object
    });
  }

  const cameraData = filterUniqueObjects(demoArr, "id").sort((a, b) => {
    return (parseInt(a.sorting, 10) || 0) - (parseInt(b.sorting, 10) || 0);
  });
  // Add Products automatically
  useEffect(() => {
    const productAddedSuccessfully = localStorage.getItem("productAdded");
    if (
      localStorage.getItem("autoSpecialDefaultsEnabled") === "1" &&
      areYouDealer !== "Dealer Selected" &&
      isProductCSVLoaded &&
      isProductOptionsCSVLoaded &&
      !productAddedSuccessfully &&
      totalNoOptions !== undefined
    ) {
      // Code to set the setFinalNewState
      setLoading(true);
      let filteredProducts = [];
      if (productCSVQuery) {
        filteredProducts = productCSVQuery.reduce((acc, item) => {
          const isSpecialAutoDefault =
            hasSpecialCategoryPath(item) && getSpecialAutoQuantity(item) > 0;

          if (isSpecialAutoDefault) {
            const isVisible =
              areYouDealer === "Dealer Selected"
                ? item.hide_2 === "0"
                : item.hide_1 === "0";

            if (isVisible) {
              acc.push(item);
            }
          }

          return acc;
        }, []);
      }
      filteredProducts.forEach((mainItem) => {
        // Code to set setFinalNewState2

        let result = [];
        let currentArray = [];
        for (let i = 0; i < productOptionCSVQuery.length; i++) {
          const item = productOptionCSVQuery[i];

          if (
            item.productid === mainItem.id ||
            (currentArray.length > 0 && item.productid === "")
          ) {
            currentArray.push(item);
          } else if (currentArray.length > 0) {
            result = currentArray;
            currentArray = [];
          }
        }
        if (currentArray.length > 0) {
          result = [...currentArray];
        }

        const result1 = [];
        let currentArray1 = [];

        for (let i = 0; i < result.length; i++) {
          const item = result[i];

          if (item.productid === mainItem.id) {
            if (currentArray1.length > 0) {
              result1.push([...currentArray1]);
              currentArray1 = [];
            }
            currentArray1.push(item);
          } else if (currentArray1.length > 0 || i === result.length - 1) {
            currentArray1.push(item);
          }
        }

        if (currentArray1.length > 0) {
          result1.push([...currentArray1]);
        }

        setFinalDatas(result1);

        // Code to find the category_name so that it could be set as the parameter value in Camera_Category_Name in newState
        const category = cameraData.find((item) => {
          return hasExactCategory(mainItem, item.category_name);
        });
        for (let i = 1; i <= totalNoOptions; i++) {
          let newState = {
            num_options: i.toString(),
            Product_Name: mainItem.id || "Unknown",
            Name: mainItem.name || "Unknown",
            image1: mainItem?.image1 || "",
            image2: mainItem?.image2 || "",
            image3: mainItem?.image3 || "",
            image4: mainItem?.image4 || "",
            Camera_Base_Price: parseFloat(mainItem.price) || 0.0,
            Camera_Final_Price: parseFloat(mainItem.price) || 0.0,
            Camera_Quantity: getSpecialAutoQuantity(mainItem),
            Camera_Category_Name: category ? category.category_name : "Unknown",
            extra_field_4: mainItem.extra_field_4 || "",
            extra_field_5: mainItem.extra_field_5,
            uniqueID:
              Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
          };

          // Conditionally add the "drop" property with value from mainItem.extra_field_2 if it exists
          if (mainItem.extra_field_2) {
            newState = {
              ...newState,
              drop: mainItem.extra_field_2,
            };
          }

          const mergedState = { ...newState, ...finalNewState2 };
          dispatch(setSelectedSpecial(mergedState));
          dispatch(setFinalData(mergedState));
          setUnitCounter(0);
        }
      });

      localStorage.setItem("productAdded", "productAdded");
      setLoading(false);
    }
  }, [isProductCSVLoaded, isProductOptionsCSVLoaded]);

  // Remove blank id code

  useEffect(() => {
    // storing data
    let newState = {
      uniqueID: dataProduct.uniqueID,
      num_options: whichOption,
      Product_Name: categoryName2,
      Name: dataProduct?.name,
      Camera_Base_Price: basePrice3,
      Camera_Final_Price: priceList,
      Camera_Quantity: count,
      Camera_Category_Name: categoryName,
      extra_field_5: dataProduct?.extra_field_5,
      thumbnail: dataProduct?.thumbnail || "",
      image1: dataProduct?.image1 || "",
      image2: dataProduct?.image2 || "",
      image3: dataProduct?.image3 || "",
      image4: dataProduct?.image4 || "",
    };
    // Conditionally add the "drop" property with value from dataProduct.extra_field_2 if it exists
    if (dataProduct?.extra_field_2 || dataProduct?.drop) {
      newState = {
        ...newState,
        drop: dataProduct?.extra_field_2
          ? dataProduct?.extra_field_2
          : dataProduct?.drop,
      };
    }

    setFinalNewState(newState);
  }, [
    dataProduct.id,
    dataProduct.price,
    count,
    priceList,
    bracketNumber,
    categoryName,
  ]);
  // Commenting it temporary
  // React.useEffect(() => {
  //   // storing data
  //   setFinalNewState({
  //     num_options: whichOption,
  //     Product_Name: categoryName2,
  //     Camera_Base_Price: basePrice3,
  //     Camera_Final_Price: priceList,
  //     Camera_Quantity: count,
  //     Camera_Category_Name: categoryName,
  //   });

  // }, [
  //   dataProduct.id,
  //   dataProduct.price,
  //   count,
  //   priceList,
  //   bracketNumber,
  //   categoryName,
  // ]);

  //***** Below Code is responsible for filling finalNewState-2 *******//
  React.useEffect(() => {
    if (!finalDatas || finalDatas.length === 0) {
      return;
    }

    const initialSelectedOptions = {};
    let initialOptionTotal = 0;

    finalDatas.forEach((item) => {
      if (item.length > 0) {
        const firstOption = item[0];
        const firstOptionPrice = parseFloat(firstOption.featureprice) || 0;

        initialSelectedOptions[firstOption.featurecaption] =
          firstOption.featurename;
        initialSelectedOptions[`${firstOption.featurecaption}_price`] =
          firstOptionPrice;
        initialOptionTotal += firstOptionPrice;
      }
    });

    setFinalNewState2(initialSelectedOptions);
    setTotalPrice(initialOptionTotal);
  }, [finalDatas]);

  //***** Below Code is responsible for filling finalNewState-2 *******//

  //************************** HandleChange ***************************//

  function handleSelectChange(e) {
    const { name, value } = e.target;

    // Return early if "Please select" is chosen (empty value)
    if (value === "") {
      // Handle the deselection case
      const prevOptionPrice = finalNewState2[name]
        ? parseFloat(
            finalDatas
              .flat()
              .find((option) => option.featurename === finalNewState2[name])
              .featureprice
          )
        : 0;

      setTotalPrice((prevTotalPrice) => prevTotalPrice - prevOptionPrice);
      setFinalNewState2((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      return;
    }

    const selectedOption = finalDatas
      .flat()
      .find((option) => option.featurename === value);

    setDisableIt(selectedOption.featurename);

    if (name === "Mounting Bracket") {
      setBracketPrice(selectedOption.featureprice);
    }
    if (name === "Audio") {
      setTwo(selectedOption.featureprice);
    }

    const prevOptionPrice = finalNewState2[name]
      ? parseFloat(
          finalDatas
            .flat()
            .find((option) => option.featurename === finalNewState2[name])
            .featureprice
        )
      : 0;

    const optionPrice = parseFloat(selectedOption.featureprice);
    const priceDifference = optionPrice - prevOptionPrice;

    setTotalPrice((prevTotalPrice) => prevTotalPrice + priceDifference);
    setFinalNewState2((prevData) => ({
      ...prevData,
      [name]: value,
      [`${name}_price`]: optionPrice,
    }));
  }

  const handlePlusClick = () => {
    setCount(count + 1);
    setCustomCount(customCount + 1);
  };

  const handleMinusClick = () => {
    if (count > 1) {
      setCount(count - 1);
    }
    if (customCount > 1) {
      setCustomCount(customCount - 1);
    }
  };

  // New

  // Increase Count by + 5
  const handlePlusClickByFive = () => {
    setCount(count + 5);
    setCustomCount(customCount + 5);
  };

  // Decrease Count by - 5
  const handleMinusClickByFive = () => {
    if (count > 5) {
      setCount(count - 5);
    }
    if (customCount > 5) {
      setCustomCount(customCount - 5);
    }
  };

  // Increase Count by +10 :
  const handlePlusClickByTen = () => {
    setCount(count + 10);
    setCustomCount(customCount + 10);
  };
  // Decrease Count by -10
  const handleMinusClickByTen = () => {
    if (count > 10) {
      setCount(count - 10);
    }
    if (customCount > 10) {
      setCustomCount(customCount - 10);
    }
  };

  // +$1 by One
  const IncreaseByDollar_One = () => {
    setUnitCounter((prev) => prev + 1);
  };

  // -$1 by
  const DecreaseByDollar_One = () => {
    if (unitCounter > 0) {
      setUnitCounter((prev) => prev - 1);
    }
  };

  // New
  //************************ calculate price **************************//

  useEffect(() => {
    const safeBasePrice = Number(basePrice3) || 0;
    const safeOptionTotal = Number(totalPrice) || 0;
    setPriceList(safeBasePrice + safeOptionTotal);
  }, [basePrice3, totalPrice]);

  const resetState = () => {
    // setPriceList(0);
    setBracketNumber("");
    // setFinalNewState({});
    setFinalNewState2({});
    // setFinalNewState3({});
    setTotalPrice(0);
    setIsDisabled(true);
    setCount(1);
  };

  React.useEffect(() => {
    updateMergedState();
    if (!show2) {
      resetState();
    }
    if (!shows) {
      resetState();
    }
  }, [show2, shows]);

  //************************* Delete Camera ***************************//

  const deleteSpecialProducts = (name, option, uniqueID) => {
    dispatch(deleteSpecial({ name, option, uniqueID }));
    dispatch(deleteLinkedLaborItems({ linkedParentUniqueID: uniqueID }));
  };

  //  Update Camera

  function updateCamera() {
    const newObj = {
      ...mergedState,
      Name: dataProduct.Name || dataProduct.name, // Ensure Name is included
    };
    dispatch(updateSpecial2(newObj));
    syncAutoServiceLabor(newObj);
    setShow2(false);
  }

  // +1 by Unit Cost

  const typedDecrement = () => {
    setUnitCostInput("");
    setBasePrice3((prev) => Math.max(0, (Number(prev) || 0) - 1));
  };

  // +1 Unit Cost
  const typedIncrement = () => {
    setUnitCostInput("");
    setBasePrice3((prev) => (Number(prev) || 0) + 1);
  };

  // Input Type Unit Cost. This edits the base unit cost only; option prices stay separate.
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setUnitCostInput(value);
      setBasePrice3(value === "" || value === "." ? 0 : parseFloat(value));
    }
  };

  const handleUnitCostFocus = () => {
    setUnitCostInput(String(basePrice3 ?? ""));
  };

  const handleUnitCostBlur = () => {
    setUnitCostInput("");
  };

  //filter table data based on num_option selected
    const filterData = tableData.filter((item) => item.option === whichOption);


  const totalSelectedCameras = useSelector((state) => {
    const cameras = state.counter1.selectedCamera;
    const filteredCameras = cameras.filter(
      (item) => item.num_options === whichOption
    );
    let total = 0;
    filteredCameras.forEach((item) => {
      if (item.Product_Quantity) {
        total += item.Product_Quantity;
      }
    });
    return total;
  });

  // useEffect(() => {
  //   let drops = 0;

  //   filterData.forEach(item => {
  //     if (item.drop) {
  //       drops += item?.drop * item?.Camera_Quantity
  //     }

  //     drops > 0 ? setTotalDrops(totalSelectedCameras + drops) : setTotalDrops(0)
  //   });

  // }, [filterData]);

  useEffect(() => {
    let numberOfSpecial = 0;

    filterData.forEach((item) => {
      //Quantity of special
      numberOfSpecial += item?.Camera_Quantity;
    });

    // If you want comparison in special use the below
    // if (whichOption && totalNoOptions !== undefined) {
    //   dispatch(updateComparisonData({ [whichOption]: { "name": 'special', "quantity": numberOfSpecial || 0, "warning": totalCamerasRequired || 0, "option": whichOption, "navigationName": "/special" } }))
    // }

    // If you don't want comparison in special use the below
    if (whichOption && totalNoOptions !== undefined) {
      dispatch(
        updateComparisonData({
          [whichOption]: {
            name: "special",
            quantity: 0,
            warning: 0,
            option: whichOption,
            navigationName: "/special",
          },
        })
      );
    }
  }, [filterData]);

  const handleCustomFields = (e) => {
    const { name, value } = e.target;
    setCustomData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // React.useEffect(() => {
  //   setMergedState((prevData) => ({
  //     ...prevData,
  //     Camera_Quantity: customCount, // Ensure the quantity is correctly set
  //     num_options: whichOption,
  //     Product_Name: CustomData.Product_Name,
  //     Name: CustomData.description,
  //     Camera_Final_Price: CustomData.price * customCount, // Update final price based on quantity
  //     thumbnail:
  //       "assets/images/products/accessories/ac-bnc/ac-bnc_2_400x335_thumbnail.jpg",
  //     Camera_Base_Price: CustomData.price,

  //   }));
  // }, [CustomData, customCount]);
  const handleCustomData = () => {
    // Update mergedState with custom product data

    if (CustomData.description === "" || CustomData.price === "") {
      alert("Please fill all the fields");
      return;
    }

    let newState = {
      uniqueID: dataProduct.uniqueID || "",
      num_options: whichOption,
      Product_Name: CustomData.Product_Name,
      Name: CustomData.description,
      Camera_Base_Price: Number(CustomData.price || 0),
      Camera_Final_Price: Number(CustomData.price || 0),
      Product_Base_Price: Number(CustomData.price || 0),
      Product_Final_Price: Number(CustomData.price || 0) * customCount,
      pricePerItem: Number(CustomData.price || 0),
      quantity: customCount,
      Camera_Quantity: customCount,
      Camera_Category_Name: "Custom",
      thumbnail: dataProduct?.thumbnail || "",
      image1: dataProduct?.image1 || "",
      image2: dataProduct?.image2 || "",
      image3: dataProduct?.image3 || "",
      image4: dataProduct?.image4 || "",
      uniqueID:
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
    };

    dispatch(setSelectedSpecial(newState));
    dispatch(setFinalData(newState));
    setShowsCustom(false);
    setCustomCount(1);
    setCustomData({
      Product_Name: "CUSTOM",
      description: "",
      price: "",
    });
    setMergedState({});
  };
  const renderSpecialOptions = (item) => {
    const options = getOptionEntries(item, [
      "Camera_Category_Name",
      "Camera_Final_Price",
      "Camera_Base_Price",
      "Camera_Quantity",
      "Product_Final_Price",
      "Product_Base_Price",
      "Product_Quantity",
      "page",
      "image",
      "thumbnail",
    ]);

    return options.map((option, optionIndex) => (
      <React.Fragment key={`${option.name}-${optionIndex}`}>
        <strong>{option.name}: </strong>
        {option.value}{" "}
        <strong>${Number(option.price || 0).toFixed(2)}</strong>
        <br />
      </React.Fragment>
    ));
  };

  return (
    <>
      <Container fluid className="my-4" style={{ backgroundColor: "" }}>
        <Container className="navbar_margin">
          <Row style={{ backgroundColor: "" }}>
            <Col className="marginTopSpace" style={{ backgroundColor: "" }}>
              <h2>
                Special Page <span className="fst-italic fs-6">(Category)</span>
              </h2>
            </Col>
            <Col className="marginTopSpace" style={{ backgroundColor: "" }}>
              <Row>
                <Col className="text-end">
                  Number of Cameras Required:&nbsp;
                  <span className="fw-bold">{totalCamerasRequired}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Total Cameras Selected:&nbsp;
                  <span className="fw-bold">{totalSelectedCameras}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <DisplayDrops />
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <Link to="/">
                    <h6>
                      Edit here <span className="fw-bold"></span>
                    </h6>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>

          {isLoading1 || isLoading2 || isLoading3 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "24px",
                fontWeight: "bold",
                color: "gray",
              }}
            >
              Loading... Please wait
            </div>
          ) : (
            <Row className="" style={{ padding: "8px" }}>
              <Col>
                <h5 className="fw-bold">Add to Cart:</h5>
                <div className="table-border">
                  <Table striped bordered hover responsive>
                  <colgroup>
                    <col style={{ width: "160px" }} />
                    <col style={{ width: "auto" }} />
                    <col style={{ width: "110px" }} />
                    <col style={{ width: "80px" }} />
                    <col style={{ width: "120px" }} />
                    <col style={{ width: "90px" }} />
                    <col style={{ width: "90px" }} />
                  </colgroup>
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Description & Options</th>
                        <th>Price</th>
                        <th>QTY</th>
                        <th>Total</th>
                        <th colSpan={2} className="text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filterData.map((item, index) => {
                        const calc = calculateLineItem({
                          ...item,
                          pricePerItem: item.Camera_Base_Price ?? item.Product_Base_Price,
                          quantity: item.Camera_Quantity ?? item.Product_Quantity,
                        });
                        return (
                          <tr key={index}>
                            <td style={{ whiteSpace: "nowrap" }}>{getProductSku(item)}</td>
                            {/* <td>{item["Hard Drive Size"] || item["Bracket"] || item["Timeframe"]}</td> */}
                            <td>
                              {item.Product_Name ? (
                                <>
                                  <strong>{getProductDisplayName(item)}</strong>
                                  {/* {item.category} */}
                                  <br />
                                </>
                              ) : null}
                              {renderSpecialOptions(item)}
                            </td>{" "}
                            <td>${calc.unitTotal.toFixed(2)}</td>
                            <td>{item.Product_Quantity}</td>
                            <td>${calc.lineTotal.toFixed(2)}</td>
                            <td>
                              <Button
                                variant="dark"
                                className="mx-3"
                                onClick={(e) =>
                                  modal_1(e, item, item.Product_Name, "edit")
                                }
                              >
                                Edit
                              </Button>
                            </td>
                            <td>
                              <Button
                                variant="dark"
                                onClick={() =>
                                  deleteSpecialProducts(
                                    item.Product_Name,
                                    item.num_options,
                                    item.uniqueID
                                  )
                                }
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          )}

          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showsCustom}
            onHide={() => setShowsCustom(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Custom Product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="my-4">
                <Col>
                  <Form.Label>SKU:</Form.Label>
                  <Form.Control
                    type="text"
                    value={CustomData.Product_Name}
                    name="Product_Name"
                    onChange={(e) => handleCustomFields(e)}
                  />
                </Col>
                <Col>
                  <Form.Label>Description:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={1}
                    value={CustomData.description}
                    name="description"
                    onChange={(e) => handleCustomFields(e)}
                  />
                </Col>
              </Row>

              <Row className="my-4 ">
                <Col>
                  <Form.Label>Price:</Form.Label>
                  <Form.Control
                    type="text"
                    value={CustomData.price}
                    name="price"
                    onChange={(e) => handleCustomFields(e)}
                  />
                </Col>
                <Col>
                  <Form.Label>Qty:</Form.Label>
                  <div
                    className="d-flex align-items-end "
                    style={{ gap: "10px" }}
                  >
                    <Button variant="dark" onClick={handleMinusClickByTen}>
                      -10
                    </Button>
                    <Button variant="dark" onClick={handleMinusClickByFive}>
                      -5
                    </Button>
                    <Button variant="dark" onClick={handleMinusClick}>
                      -
                    </Button>
                    <h6 className="mx-3">{customCount}</h6>
                    <Button variant="dark" onClick={handlePlusClick}>
                      +
                    </Button>
                    <Button variant="dark" onClick={handlePlusClickByFive}>
                      +5
                    </Button>
                    <Button variant="dark" onClick={handlePlusClickByTen}>
                      +10
                    </Button>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="dark" onClick={() => handleCustomData()}>
                Add Custom
              </Button>
              <Button variant="dark" onClick={() => setShowsCustom(false)}>
                Close Custom
              </Button>
            </Modal.Footer>
          </Modal>

          <div className="d-flex justify-content-end align-items-center">
            {/* Show the warning to the before he moves to the next category */}
            <Button
              variant="dark"
              style={{
                marginRight: "10px",
              }}
              onClick={() => setShowsCustom(true)}
            >
              Custom
            </Button>
            {showWarningComponent ? (
              <WarningComponent
                path="/hardware"
                setShowWarningComponent={setShowWarningComponent}
              />
            ) : (
              ""
            )}
            <Button
              variant="dark"
              onClick={() => setShowWarningComponent(true)}
            >
              Next
            </Button>
          </div>

          {/* Camera Data Cards */}

          <Row className="my-4" style={{ backgroundColor: "" }}>
            {cameraData.map((item, index) => (
              <Col
                key={index}
                md={4}
                className="mb-4"
                onClick={(e) => handleButtonClick(e, item.category_name)}
              >
                <Card style={{ width: "", margin: "" }}>
                  <Card.Body>
                    <Row
                      style={{
                        height: "185px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Col xs={7}>
                        <Card.Img
                          variant="top"
                          style={{
                            width: "100%",
                            height: "auto",
                            // aspectRatio: "1",
                            border: "0px solid grey",
                          }}
                          src={
                            item.iconimage === ""
                              ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                              : "https://platinumcctv.com/" + item.iconimage
                          }
                        />
                      </Col>
                      <Col
                        xs={5}
                        className="align-items-center justify-content-center fw-bold"
                      >
                        <Card.Text className="fs-6">
                          {item.category_name}
                        </Card.Text>
                        <p className="camera_category_title">
                          {item.category_title || item.category_name}
                          <br />
                          {item.category_description.split(" ").length > 12
                            ? `${item.category_description
                                .split(" ")
                                .slice(0, 12)
                                .join(" ")}...`
                            : item.category_description}
                        </p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Next Page Button */}
          {/* <Row className="my-4" style={{ backgroundColor: "" }}>
            <Col className="d-flex justify-content-end">
              <Button variant="dark" onClick={handleShow2}>
                Next
              </Button>
            </Col>
          </Row> */}

          {/* Modal Code - 1 */}
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={() => setShow(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{categoryName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="my-4">
                {filteredData.map((item, index) => {
                  const uniqueKey = `${item.id}-${index}`;
                  return (
                    <Col
                      key={uniqueKey}
                      md={4}
                      className="nvr_col my-2"
                      onClick={(e) => modal_1(e, item, item.id, "add")}
                    >
                      <Card
                        style={{
                          width: "",
                          backgroundColor: "",
                          height: "300px",
                        }}
                      >
                        <Card.Body>
                          <Card.Title className="fw-bold">
                            SKU : {item.id}
                          </Card.Title>
                          <Card.Text>
                            Description :
                            {item.name.split(" ").length > 10
                              ? `${item.name
                                  .split(" ")
                                  .slice(0, 10)
                                  .join(" ")}...`
                              : item.name}
                          </Card.Text>
                          <Row>
                            <Col xs={8}>
                              <Card.Img
                                variant="top"
                                height={100}
                                src={
                                  item.thumbnail === ""
                                    ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                    : "https://platinumcctv.com/" +
                                      item.thumbnail
                                }
                              />
                            </Col>
                            <Col
                              xs={4}
                              className="d-flex align-items-center justify-content-center fw-bold"
                            >
                              ${" "}
                              {areYouDealer !== "Dealer Selected"
                                ? item.price
                                : item.price_2}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="dark" onClick={() => setShow(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal-2 */}
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show2}
            onHide={() => setShow2(false)}
          >
            <Modal.Header closeButton style={{ backgroundColor: "" }}>
              <Modal.Title>{categoryName2}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>
                <Row>
                  {filteredData2.map((val, index) => (
                    <React.Fragment key={index}>
                      <Col md={5}>
                        <Row>
                          <Card.Img
                            variant="top"
                            style={{
                              objectFit: "cover",
                              width: "200px",
                              height: "160px",
                              backgroundColor: "",
                              margin: "0 auto",
                            }}
                            src={
                              thumbimg.img1
                                ? "https://platinumcctv.com/" + thumbimg.img1
                                : "https://platinumcctv.com/" + val["image1"]
                            }
                            // src={
                            //   thumbimg.img1 === ""
                            //     ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                            //     : "https://platinumcctv.com/" + val["image1"]
                            // }
                          />
                        </Row>
                        <Row className="my-2">
                          {[val.image1, val.image2, val.image3, val.image4].map(
                            (image, imageIndex) => (
                              <Col key={imageIndex}>
                                <Card.Img
                                  variant="top"
                                  height={40}
                                  className="camera_thumbnail_img"
                                  // src={image}
                                  src={
                                    image === ""
                                      ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                      : "https://platinumcctv.com/" + image
                                  }
                                  onClick={() => setThumbimg({ img1: image })}
                                />
                              </Col>
                            )
                          )}
                        </Row>

                        {/* Final Price */}
                        <Row className="tops">
                          <div className="w-100 my-1 d-flex align-items-start">
                            <div className="text">
                              <Table
                                striped
                                bordered
                                hover
                                responsive
                                style={{ width: "14rem" }}
                              ></Table>
                            </div>
                          </div>
                        </Row>
                      </Col>
                      <Col md={7}>
                        <p className="fst-italic">
                          <span className="fw-bold">Description: </span>
                          {val.description || val.categories}
                          <br />
                          {val.name}
                        </p>

                        {/* Add Dropdown */}
                        {finalDatas.map((item, index) => (
                          <React.Fragment key={index}>
                            <Form.Label>{item[0].featurecaption}</Form.Label>
                            <Form.Select
                              aria-label="Default select example"
                              className="mb-3"
                              name={item[0].featurecaption}
                              value={
                                finalNewState2[item[0].featurecaption] || ""
                              }
                              onChange={handleSelectChange}
                            >
                              {item.map((option, optionIndex) => (
                                <option
                                  key={optionIndex}
                                  value={option.featurename}
                                >
                                  {option.featurename +
                                    " $ " +
                                    option.featureprice}
                                </option>
                              ))}
                            </Form.Select>
                          </React.Fragment>
                        ))}

                        <div
                          className="d-flex align-items-end justify-content-between my-4"
                          style={{ backgroundColor: "" }}
                        >
                          Qty :
                          <Button
                            variant="dark"
                            onClick={handleMinusClickByTen}
                          >
                            -10
                          </Button>
                          <Button
                            variant="dark"
                            onClick={handleMinusClickByFive}
                          >
                            -5
                          </Button>
                          <Button variant="dark" onClick={handleMinusClick}>
                            -
                          </Button>
                          <h6 className="mx-3">{count}</h6>
                          <Button variant="dark" onClick={handlePlusClick}>
                            +
                          </Button>
                          <Button
                            variant="dark"
                            onClick={handlePlusClickByFive}
                          >
                            +5
                          </Button>
                          <Button variant="dark" onClick={handlePlusClickByTen}>
                            +10
                          </Button>
                        </div>
                        <div className="text-end mb-3">
                          Option Cost: {(Number(totalPrice) || 0).toFixed(2)}
                        </div>
                        {/* Unit Cost Div */}
                        <div className="d-flex align-items-center justify-content-end">
                          <InputGroup className="mb-3">
                            Unit Cost:
                            <Button
                              variant="dark"
                              className="mx-3"
                              onClick={typedDecrement}
                            >
                              -
                            </Button>
                            <Form.Control
                              type="text"
                              value={unitCostInput !== "" ? unitCostInput : (Number(basePrice3) || 0).toFixed(2)}
                              onFocus={handleUnitCostFocus}
                              onBlur={handleUnitCostBlur}
                              onChange={handleInputChange}
                            />
                            <Button
                              variant="dark"
                              className="mx-3"
                              onClick={typedIncrement}
                            >
                              +
                            </Button>
                          </InputGroup>
                        </div>
                        <div>
                          <h4 className="text-end mt-4">
                            Total Price:{" "}
                            {((Number(priceList) || 0) * (Number(count) || 0))
                              .toFixed(2)
                              .replace(/\.?0+$/, "")}
                          </h4>
                        </div>
                      </Col>
                    </React.Fragment>
                  ))}
                </Row>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              <div className="w-100 my-4 d-flex align-items-end justify-content-between">
                <Button
                  className="mx-3"
                  variant="dark"
                  onClick={() => setShow2(false)}
                >
                  Back
                </Button>
                {showButtons === "edit" ? (
                  <Button variant="dark" onClick={updateCamera}>
                    Update Item
                  </Button>
                ) : (
                  <Button variant="dark" onClick={addCamera}>
                    Add
                  </Button>
                )}
              </div>
            </Modal.Footer>
          </Modal>

          {/* Modal-3 */}
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show3}
            onHide={() => setShow3(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Warning!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>Less Brackets Than Camera!</Container>
            </Modal.Body>
            <Modal.Footer>
              <div className="w-100 my-4 d-flex align-items-end justify-content-between">
                <Button
                  className="mx-3"
                  variant="dark"
                  onClick={() => setShow3(false)}
                >
                  Go Back
                </Button>
                <Button variant="dark" onClick={() => setShow3(false)}>
                  Continue Anyways
                </Button>
              </div>
            </Modal.Footer>
          </Modal>

          {/* Warning Modal */}
          <Modal show={shows} onHide={handleClose2}>
            <Modal.Header closeButton>
              <Modal.Title>
                <h6>
                  <span>Warning!</span>&nbsp; Number of cameras is not equal to
                  quantity of cameras.
                </h6>
              </Modal.Title>
            </Modal.Header>
            {/* <Modal.Body>Are you sure you want to continue?</Modal.Body> */}
            <Modal.Footer>
              <Button variant="dark" onClick={handleClose2}>
                Go Back
              </Button>
              <Button variant="dark" onClick={() => navigate("/hardware")}>
                Continue Anyways
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </Container>
    </>
  );
}

export default Special;
